import VehicleList from "./VehicleList";

/**
 * VehicleListOverview
 * Handles all JS stuff for vehicle list overview
 */
export default class VehicleListOverview {


    /**
     * constructor
     *
     * @param selector
     */
    constructor(selector) {

        let _this = this;
        this.$plugin = $(selector);
        let $plugin = this.$plugin;

        // cancel if non existing element
        if (this.$plugin.length === 0) {
            return false;
        }

        // check router event
        window.addEventListener("router", function (e) {

            // routing switch
            switch (e.detail.path.substring(0,4)) {
                case '#!/0':
                    _this.vehiclesByTuev();
                    break;
                case '#!/1':
                    _this.vehiclesNotByTuev();
                    break;
            }
        });

        // advanced filter toggle
        $plugin.on('click', '[data-tncp-elementtoggler-trigger]', function () {
            let value = $(this).data('tncpElementtogglerTrigger');
            $plugin.find('[data-tncp-viewmode-value]').val(value);
        });
    }

    /**
     * vehiclesByTuev
     */
    vehiclesByTuev() {
        if (this.byTuevFilter instanceof VehicleList === false) {
            this.byTuevFilter = new VehicleList('[data-tncp-plugin="VehicleListByTuev"]');
        }
    }

    /**
     * vehiclesNotByTuev
     */
    vehiclesNotByTuev() {
        if (this.notByTuevFilter instanceof VehicleList === false) {
            this.notByTuevFilter = new VehicleList('[data-tncp-plugin="VehicleListNotByTuev"]');
        }
    }
}

